import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Authenticator } from "@aws-amplify/ui-react";
import { ApolloProviderWrapper } from "./components/ApolloProviderWrapper";
import { awsConfig, launchDarklyConfig } from "./config";
import AgencyPermissionValidationContextProvider from "./context/AgencyPermissionValidationContext";
import LaunchDarklyProvider from "./utils/launchdarkly/LaunchDarklyProvider";
import Pendo from "./utils/pendo/Pendo";
import { Amplify } from "aws-amplify";
import { I18n } from "aws-amplify/utils";
import { activeLocale } from "./resources/strings";
import { amplifyEsDictionary } from "./resources/amplifyEs";

Amplify.configure(awsConfig, {
  Storage: {
    S3: {
      prefixResolver: async () => {
        return ``;
      },
    },
  },
});

// Localize the Amplify Authenticator (login screen) to match the app locale.
// The es dictionary ships in the main bundle (~2 kB gz) for everyone — judged
// not worth an async pre-render seam to code-split — but registration is
// gated so English behavior is untouched; Amplify's built-in default is
// English. The <html lang> attribute must match the rendered language or
// screen readers pronounce Spanish text with an English voice profile.
if (activeLocale === "es") {
  I18n.putVocabulariesForLanguage("es", amplifyEsDictionary);
  I18n.setLanguage("es");
  document.documentElement.lang = "es";
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// Info on React Strict Mode: https://legacy.reactjs.org/docs/strict-mode.html
root.render(
  <React.StrictMode>
    <Authenticator.Provider>
      <ApolloProviderWrapper>
        <BrowserRouter>
          <AgencyPermissionValidationContextProvider>
            <LaunchDarklyProvider
              clientSideID={launchDarklyConfig.clientSideID}
            >
              <Pendo />
              <App />
            </LaunchDarklyProvider>
          </AgencyPermissionValidationContextProvider>
        </BrowserRouter>
      </ApolloProviderWrapper>
    </Authenticator.Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
